import Fieldset from './Fieldset.jsx';

export default Fieldset;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/Fieldset/index.js